import { api, ApiRequestConfig } from './api';
import { FetchLoyaltyAccountDTO } from '../types/loyalty';
import { LOYALTY_ACCOUNT_API } from './constants';

interface IGetLoyaltyAccountParams {
  regionId: string;
}

export const getLoyaltyAccountRequest = (params: IGetLoyaltyAccountParams, config: ApiRequestConfig) =>
  api.get<FetchLoyaltyAccountDTO>(LOYALTY_ACCOUNT_API, { ...params }, config);
